export default __webpack_public_path__ + "static/media/home-main.bc70ab86.svg";